<script setup>
import { computed, watch } from 'vue'

const statusMapping = {
  empty: { icon: 'empty-square', next: 'full', name: 'empty' },
  intermediary: { icon: 'minus-square', next: 'full', name: 'intermediary' },
  full: { icon: 'tick-square', next: 'empty', name: 'full' },
}

const model = defineModel({ type: String, default: 'empty' })

const changeValue = statusItem => {
  model.value = statusItem.next
}

const activeStatus = computed(() => statusMapping[model.value])

watch(model, (newVal, oldVal) => {
  if (oldVal !== newVal) {
    emit('statusChange', oldVal, newVal)
  }
  emit('update:modelValue', newVal)
})

const emit = defineEmits(['statusChange'])
</script>

<template>
  <div class="border-0 bg-transparent px-0">
    <ImoIcon
      :key="`icon-${activeStatus.name}`"
      :name="activeStatus.icon"
      class="cursor-pointer"
      :size="16"
      @click="changeValue(activeStatus)"
    />
  </div>
</template>
